module.exports = __webpack_public_path__ + "static/media/Wooper_gaussian2.45da566e.png";